import { h } from 'hyperapp'

export default () =>
    <div class="header-logo">
        <svg version="1.1" id="logo" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 480 100" class="svg-content" preserveAspectRatio="xMinYMin meet">
            <rect id="bg" x="-0.2" y="-0.2" class="bg-league" width="480.2" height="100"></rect>
            <rect id="stroke" x="4" y="4.9" class="stroke-league" width="472" height="90.3"></rect>
            <g id="texte">
                <rect x="42.9" y="17" class="grey-league" width="8.7" height="66"></rect>
                <path class="grey-league"
                    d="M94,17c-1.8,0-3.7,0-5.5,0c-2.8,5.1-5.7,10.3-8.5,15.4c-2.9-5.1-5.7-10.3-8.6-15.4c-1.4,0-2.7,0-4.1,0h-7v66
                    h8.7V31.6c2.1,3.7,4.3,7.3,6.4,11V83H84V42.6c2.1-3.4,4.3-6.7,6.4-10.1V83h8.7V17H94z"
                ></path>
                <path class="grey-league"
                    d="M129.7,83.1h8.7c-2.5-22.1-5.1-44.1-7.6-66.2c-2.1,0-4.1,0-6.2,0l0,0h-8.7l-8,66h8.7l1.2-10.1
                    c3.5,0,7,0,10.5,0.1C128.8,76.3,129.2,79.7,129.7,83.1z M119,63L119,63l3.8-31.3c1.4,10.5,2.8,20.9,4.2,31.4
                    C124.4,63,121.7,63,119,63z"
                ></path>
                <path class="grey-league"
                    d="M323.9,83.1h8.7C330,61.1,327.5,39,324.9,17c-2.1,0-4.1,0-6.2,0l0,0h-8.7l-8,66h8.7l1.2-10.1
                    c3.5,0,7,0,10.5,0.1C322.9,76.3,323.4,79.7,323.9,83.1z M313.2,63L313.2,63l3.8-31.3c1.4,10.5,2.8,20.9,4.2,31.4
                    C318.5,63,315.9,63,313.2,63z"
                ></path>
                <path class="grey-league"
                    d="M206.7,28.9c-1,3.3-2.1,6.6-3.1,10c-2.5,0-5.1,0-7.6,0c2.1,1.6,4.2,3.3,6.2,4.9c-0.7,2.7-1.5,5.5-2.2,8.2
                    c2.3-1.6,4.5-3.2,6.8-4.8c2.4,1.6,4.7,3.2,7.1,4.8c-0.8-2.7-1.6-5.4-2.5-8c2-1.7,4-3.4,6-5.1c-2.5,0-5.1,0-7.6,0
                    C208.7,35.5,207.7,32.2,206.7,28.9z"
                ></path>
                <path class="grey-league"
                    d="M171.7,67.8c-3-2.1-6-4.3-8.9-6.4l0.1,12.5c-2.4,0-4.8,0-7.1-0.1V26.1c2.4,0,4.8,0,7.1-0.1l-0.1,12.5
                    c3-2.1,6-4.3,8.9-6.4c0-6.4,0-8.8,0.1-15.1c-5.8,0-11.5,0.1-17.3,0.1h-3.4c-2.3,0-4.1,1.9-4.1,4.1v57.7c0,2.3,1.9,4.1,4.1,4.1h4.6
                    c5.4,0,10.7,0,16.1,0C171.8,76.6,171.7,74.2,171.7,67.8z"
                ></path>
                <path class="grey-league"
                    d="M261.7,73.6h-12V17H241v66c6.9,0,13.8,0,20.7,0V73.6z"
                ></path>
                <path class="grey-league"
                    d="M402.9,16.9h-8.7v56.7h-8.3V16.9h-8.7v66c8.6,0,17.2,0,25.7,0V16.9z"
                ></path>
                <path class="grey-league"
                    d="M293.5,26.3V17h-14.3v0h-8.7v66c7.7,0,15.4,0,23,0v-9.3h-14.3V52H290l2-9.3h-12.8V26.3H293.5z"
                ></path>
                <path class="grey-league"
                    d="M435,26.3v-9.3h-14.3v0h-8.7v66c7.7,0,15.4,0,23,0v-9.3h-14.3V52h10.8l2-9.3h-12.8V26.3H435z"
                ></path>
                <path class="grey-league"
                    d="M356.4,46.7c-0.9,3-1.9,6-2.8,9c1.7,0,3.4,0.1,5.1,0.1c0,6,0,12,0,17.9c-2.8,0-5.7,0-8.5,0V26.3c3,0,6.9,0,9,0
                    l-0.1,16.5c3-2.1,6-4.3,8.9-6.4c0-6.4,0-12.8,0.1-19.1c-2.9,0-5.8,0-8.7,0c-6,0-12,0-17.9,0v66c4.9,0,9.7,0,14.6-0.1
                    c1.6-0.6,3.2-1.2,4.8-1.9c0.3,0.6,0.5,1.1,0.8,1.7c2.2,0,4.4,0,6.6,0.1c0-12,0-24.1,0-36.1C364.3,46.8,360.3,46.8,356.4,46.7z"
                ></path>
            </g>
        </svg>
    </div>
